export function About() {
    const teamMembers = [
        { members: [{ name: "Dimitre Iliev", email: "Dimitre.Iliev@vossloh.com" }, { name: "Stefan Distlberger", email: "Stefan.Distlberger@vossloh.com" }, { name: "Winfried Bösterling", email: "Winfried.Boesterling@vossloh.com" }], role: "Product Owner" },
        { members: [{ name: "Viktor Ratza", email: "viktor.ratza@vossloh.com" }], role: "Project Manager" },
        { members: [{ name: "Hamed Rahmatollahi", email: "hamed.rahmatollahi@vossloh.com" }], role: "Solution Architect" },
        {
            role: "Technical Support",
            members: [
                { name: "Moein Golsorkh", email: "moein.golsorkh@vossloh.com" },
                { name: "Nimisha Sunny", email: "nimisha.sunny@vossloh.com" }
            ],
        },
    ];

    return (
        <div className="flex flex-col h-screen overflow-y-auto">
            {/* Main content area with two columns */}
            <main className="flex-grow p-6 pt-20 max-w-6xl mx-auto">
                <h1 className="text-3xl font-bold mb-8 text-[#33AE33]">About Us</h1>

                {/* Custom grid with 70/30 split */}
                <div className="grid grid-cols-1 md:grid-cols-[70%_30%] gap-20">
                    {/* Left: Content (70%) */}
                    <section>
                        <p className="text-lg text-gray-700 leading-relaxed mb-6">
                            Vossloh has developed a digital model for predicting and preventing thermally induced track buckling on hot days in continuously welded ballasted tracks as a result of high rail compressive stresses. Meier's energy method is used as the mathematical basis for calculating lateral track stability.
                            On the one hand, the maximum possible track resistance up to a buckling is calculated for both straight sections and curves using appropriate formulas. The most important parameters influencing the resistance of the track are the lateral sleeper resistance, the equivalent moment of inertia of the track grid, the rail profile, the lateral track misalignment error and the curve radius.            </p>
                        <p className="text-lg text-gray-700 leading-relaxed">
                            On the other hand, the model can be used to calculate the maximum thermal load (impact) as the sum of rail heating, dynamic influences during a train passage, the presence of engineering structures, vegetation, etc.
                            The comparison of track resistance with the sum of the impacts is used as the basis for deriving a potential buckling. If the track resistance is less than the impact, track buckling occurs. Conversely, if track resistance is greater than the impact, lateral track stability is guaranteed.
                        </p>
                        <p className="text-lg text-gray-700 leading-relaxed">
                            To calculate lateral track stability accurately, the model takes into account more than 30 individual track parameters and complex relationships between the parameters. The reliability of the results is based on many years of internal expertise, numerous international publications and measurements taken in the laboratory and on track. All this leads to the most accurate possible prediction of track distortions, making the model unique worldwide.
                            Furthermore, several safety levels are integrated into the model, which are visually represented by different colors. If a certain safety level is exceeded, various preventive measures are suggested to the customer, such as reducing speed, replacing track components or eliminating lateral misalignments in the track. The effect of these measures is calculated by the model and then displayed both numerically and in color for the individual track sections under consideration.
                        </p>
                    </section>

                    {/* Right: Team (30%) */}
                    <section>
                        <h2 className="text-2xl font-semibold mb-6 text-[#33AE33]">
                            Our Development Team
                        </h2>
                        <div className="space-y-6">
                            {teamMembers.map((group) => (
                                <div key={group.role}>
                                    <h3 className="text-xl font-medium mb-2 text-[#33AE33]">
                                        {group.role}
                                    </h3>
                                    <ul className="space-y-1 pl-4">
                                        {group.members.map((member) => (
                                            <li key={member.email} className="text-gray-700">
                                                <span className="font-medium">{member.name}</span>{" "}
                                                <a
                                                    href={`mailto:${member.email}`}
                                                    className="text-sm text-[#155dfc] hover:underline"
                                                >
                                                    ({member.email})
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </section>
                </div>
                {/* Footer */}
                <footer className="bg-gray-100 border-t py-4 mt-8 text-center text-sm text-gray-600">
                    <p>
                        © {new Date().getFullYear()} Vossloh
                    </p>
                </footer>
            </main>
        </div>
    );
}

